import * as React from "react"
import { cn } from "@/lib/utils"

export interface CopyIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Copy icon as SVG (duplicate document symbol)
 *
 * This icon represents the copy-to-clipboard action in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <CopyIcon />
 * <CopyIcon size={12} className="text-gray-500" />
 * ```
 */
export const CopyIcon = React.forwardRef<SVGSVGElement, CopyIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 13 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M3.2,3.7v-1.5c0-.7.2-1.2.5-1.5.4-.4.9-.5,1.5-.5h2.1c.4,0,.7,0,1,.2.3.1.6.3.8.5l2.9,2.9c.2.3.4.5.5.8.1.3.2.7.2,1.1v4.4c0,.7-.2,1.2-.5,1.5-.4.4-.9.5-1.5.5h-1.2v-1.5h1c.2,0,.4,0,.6-.2.1-.1.2-.3.2-.5v-4.6h-2.3c-.4,0-.7-.1-.9-.3-.2-.2-.3-.5-.3-.9V1.7h-2.2c-.2,0-.4,0-.6.2-.1.1-.2.3-.2.5v1.3h-1.5ZM8.8,4c0,0,0,.2,0,.2,0,0,.1,0,.2,0h1.8l-2-2.1v1.8ZM.2,13.3v-7.9c0-.7.2-1.2.5-1.5.4-.4.9-.5,1.5-.5h2c.4,0,.7,0,1,.1.3,0,.5.3.8.5l3.1,3.1c.2.2.3.4.4.5,0,.2.2.4.2.6,0,.2,0,.4,0,.7v4.4c0,.7-.2,1.2-.5,1.5-.4.4-.9.5-1.5.5H2.3c-.7,0-1.2-.2-1.5-.5-.4-.4-.5-.9-.5-1.5ZM1.7,13.2c0,.2,0,.4.2.5.1.1.3.2.6.2h5.1c.2,0,.4,0,.5-.2.1-.1.2-.3.2-.5v-3.9h-2.7c-.5,0-.9-.1-1.1-.4-.2-.2-.4-.6-.4-1.1v-2.9h-1.6c-.2,0-.4,0-.6.2-.1.1-.2.3-.2.5v7.6ZM5.7,8h2.5l-2.9-2.9v2.5c0,.1,0,.2,0,.3,0,0,.2,0,.3,0Z" />
      </svg>
    )
  }
)

CopyIcon.displayName = "CopyIcon"
